import { Helmet } from "react-helmet-async";

const SEO = ({
  title,
  metatitle,
  description,
  keywords,
  canonical,
  schema,
}) => {

  const isLandingPage = 
    canonical === "https://www.transforma.in" || 
    canonical === "https://www.transforma.in/";
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="title" content={metatitle??title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />

      {!isLandingPage && (
        <>
          <meta property="og:title" content={title} />
          <meta property="og:description" content={description} />
        </>
      )}

      <link rel="canonical" href={canonical} />

      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;